import { useAppSelector } from '../../../../store/hooks'
import PageHeader from '../../../layout/page/PageHeader'
import SocialMediaLinkForm from './SocialMediaLinkForm'

const SocialMediaLinks = () => {
    const theme = useAppSelector((state) => state.theme.theme)

    return (
        <>
            <PageHeader
                icon="share-nodes"
                subtitle="Configure social media links and integrations"
                gradient="linear-gradient(135deg, #06b6d4, #0891b2)"
                header="Social Media Links"
                buttons={[
                    {
                        variant: theme === 'dark' ? 'dark' : 'light',
                        label: 'Back to Administration',
                        icon: 'fa-solid fa-arrow-left',
                        url: '/administration',
                    },
                ]}
            />
            <SocialMediaLinkForm
                config={{
                    submitSuccessMsg: {
                        header: 'Updated',
                        message: 'Social Media Links updated successfully',
                    },
                    submitFailedMsg: {
                        header: 'Failed',
                        message: 'Failed to update social media links',
                    },
                    saveButton: {
                        label: 'Update',
                        savingLabel: 'Updating social media links...',
                    },
                }}
                inPopup={false}
            />
        </>
    )
}

export default SocialMediaLinks
